export const getSpeakerLayoutBorderKey = (value: boolean) => (value ? 'with-border' : 'without-border');

export const getParticipantIndex = (layoutType: 'GRID' | 'FOCUS', totalParticipant: number): number => {
  return (layoutType === 'FOCUS' ? 1 : 0) + totalParticipant;
};
